import React from "react";
import Badge from "react-bootstrap/Badge";

const ConstantsTable = ({ data, handleEdit, total }) => {
  return (
    <table className="table table-hover">
      <caption style={{ captionSide: "top", paddingBottom: 0 }}>
        {total} Constants
      </caption>
      <thead>
        <tr>
          <th>Parameter</th>
          <th>Heading 1</th>
          <th>Heading 2</th>
          <th>Heading 3</th>
          <th>In Use</th>
          <th>Min</th>
          <th>Max</th>
          <th>Constant Value</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {data.map((parameter) => (
          <tr
            key={parameter.CODE}
            className={parameter.IN_USE_FLAG ? "" : "bg-light"}
          >
            <td className="text-nowrap">{parameter.CODE}</td>
            <td>{parameter.HEADING1}</td>
            <td>{parameter.HEADING2}</td>
            <td>{parameter.HEADING3}</td>
            <td>
              {parameter.IN_USE_FLAG ? (
                <Badge variant="success">True</Badge>
              ) : (
                <Badge variant="warning">False</Badge>
              )}
            </td>
            <td>{parameter.LOWER_ABS_LIMIT}</td>
            <td>{parameter.UPPER_ABS_LIMIT}</td>
            <td>{parameter.CONSTANT_VALUE}</td>
            <td className="text-nowrap">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => handleEdit(parameter)}
                disabled={!parameter.IN_USE_FLAG}
              >
                Edit Value
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ConstantsTable;
